/* eslint-disable unicorn/filename-case -- kebab-case per docs/conventions/core.md: exports a function, not a component. */
import type { RowData } from '@tanstack/react-table';

import type { Column } from './DimeDataTable.types.js';

/** Cycles asc -> desc -> none; Hide lives in the Columns menu, so sorting has no dropdown. */
export function cycleColumnSort(
  column: Pick<Column<RowData, unknown>, 'getIsSorted' | 'toggleSorting' | 'clearSorting'>,
): void {
  const sorted = column.getIsSorted();
  if (sorted === 'asc') {
    column.toggleSorting(true);
  } else if (sorted === 'desc') {
    column.clearSorting();
  } else {
    column.toggleSorting(false);
  }
}
